const getTime = (t) => {
  if(typeof(t) == 'string') {
    const [ hour, minute, second ] = t.split(':')
    return {
      hour: parseInt(hour),
      minute: parseInt(minute || 0),
      second: parseInt(second || 0),
    }
  }
  else if(typeof(t) == 'number') {
    const hour = Math.floor(t)
    return {
      hour,
      minute: Math.round((t - hour) * 100),
      second: 0,
    }
  }
  else {
    return t
  }
}

const getDateFromTime = (t) => {
  if(typeof t.getMonth === 'function') return t
  const parsedTime = getTime(t)
  const dt = new Date()
  dt.setHours(parsedTime.hour)
  dt.setMinutes(parsedTime.minute)
  dt.setSeconds(0)
  dt.setMilliseconds(0)
  return dt
}

const getTimeFromDate = (dt) => {
  return {
    hour: dt.getHours(),
    minute: dt.getMinutes(),
    second: 0,
  }
}

const getTimeNumberFromTime = (t) => {
  return t.hour + (t.minute/100)
}

const getRange = (t, mins) => {
  t = getTime(t)
  const dt = new Date()
  dt.setHours(t.hour)
  dt.setMinutes(t.minute)
  dt.setSeconds(0)
  const endDate = new Date(dt.getTime() + (1000 * 60 * mins))
  return {
    start: t,
    end: {
      hour: endDate.getHours(),
      minute: endDate.getMinutes(),
      second: 0,
    }
  }
}

const getTitle = (t) => {
  t = getTime(t)
  const hour = `${t.hour}`.length == 1 ?
    `0${t.hour}` :
    t.hour
  const minute = `${t.minute}`.length == 1 ?
    `0${t.minute}` :
    t.minute
  return [hour, minute].join(':')
}

const getRangeTitle = (range) => {
  if(!range || !range.start) return ''
  if(!range.end) return getTitle(range.start)
  return [
    getTitle(range.start),
    getTitle(range.end),
  ].join(' - ')
}

module.exports = {
  getTime,
  getRange,
  getTitle,
  getRangeTitle,
  getDateFromTime,
  getTimeNumberFromTime,
  getTimeFromDate,
}